export const formSubmitValueMapper = (data = {}) => ({
  tgl_nilai_perolehan_aset: data?.tgl_nilai_perolehan_aset,
  id_produksi_aset: data?.id_produksi_aset,
  id_item_aset: data?.id_item_aset,
  jumlah: data?.jumlah,
  nomor_coa_debet: data?.nomor_coa_debet,
  nomor_coa_kredit: data?.nomor_coa_kredit,
  keterangan_jurnal: data?.keterangan_jurnal,
});
